import { DeleteSmsTemplateMeta, DeleteSmsTemplatePayload } from 'types/store/DeleteSmsTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { deleteSmsTemplateActions } from '../actions';

export default createAsyncReducer<DeleteSmsTemplateMeta, DeleteSmsTemplatePayload>(deleteSmsTemplateActions);
